import { format, parse, getISODay } from 'date-fns';
import { lv, ru } from 'date-fns/locale';
import { currentLang } from './lang';
const locales = { lv, ru };
const currentLocale = locales[currentLang()];
export const parseDate = (dateString, formatString) => parse(dateString, formatString, 0);
export const formatDate = (date, formatString) => format(date, formatString, { locale: currentLocale });
export const romanDay = (date) => ['I', 'II', 'III', 'IV', 'V', 'VI', 'VII'][getISODay(date) - 1];
